import {Component, Input, OnInit} from "@angular/core";
import {ContentElement} from "../../../campaigns/models/content-element";

@Component({
  selector: "app-heading3",
  templateUrl: "./heading3.component.html",
  styleUrls: ["./heading3.component.scss"]
})
export class Heading3Component {
  @Input()
  ce: ContentElement;

  constructor() {}
}
